// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper-label-container{margin:0 !important}.stepper-label-container span{font-size:16px !important}.add-alert-wrapper .MuiStepper-vertical{padding-left:20px !important}.add-alert-wrapper .user-select-none{width:auto !important}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
